module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_icloud-1079b1498e711ce165ef960046b699ca.png";